import React, { RefObject } from "react";
import { EpRight } from "../../../components/college-details/components/CoursesFeesTab";

interface Stream {
  name: string;
  title: string;
}

interface StreamTabsProps {
  streams: Stream[];
  activeStream: string;
  handleTabChange: (stream: string) => void;
  scroll: (direction: "left" | "right") => void;
  scrollContainerRef: RefObject<HTMLDivElement>;
}

const StreamTabs: React.FC<StreamTabsProps> = ({
  streams,
  activeStream,
  handleTabChange,
  scroll,
  scrollContainerRef,
}) => {
  if (streams.length === 0) return null;

  return (
    <div className="w-full flex items-center justify-center gap-1">
      {streams.length > 0 && (
        <button
          className="p-3 bg-white border border-solid border-black rounded-full cursor-pointer text-center"
          onClick={() => scroll("left")}
        >
          <EpRight className="rotate-180" />
        </button>
      )}
      <div
        ref={scrollContainerRef}
        className="flex overflow-x-auto whitespace-nowrap scrollbar-hide gap-2"
        style={{ scrollBehavior: "smooth" }}
      >
        {streams.map((stream) => (
          <button
            key={stream.name}
            className={`px-6 py-2 text-base rounded-md whitespace-nowrap ${
              activeStream === stream.name
                ? "bg-green text-white"
                : "bg-white text-gray-600"
            }`}
            onClick={() => handleTabChange(stream.name)}
          >
            {stream.title}
          </button>
        ))}
      </div>
      {streams.length > 0 && (
        <button
          className="p-3 bg-white border border-solid border-black rounded-full cursor-pointer text-center"
          onClick={() => scroll("right")}
        >
          <EpRight />
        </button>
      )}
    </div>
  );
};

export default StreamTabs;
